let SemanticState = /*#__PURE__*/function (SemanticState) {
  SemanticState[SemanticState["Default"] = 1] = "Default";
  SemanticState[SemanticState["Error"] = 2] = "Error";
  SemanticState[SemanticState["Warning"] = 3] = "Warning";
  SemanticState[SemanticState["Success"] = 4] = "Success";
  return SemanticState;
}({});

export { SemanticState };
//# sourceMappingURL=semantic-state.js.map
